module.exports = __webpack_public_path__ + "img/illustrator-mission.6c2cefd5.svg";